import * as urlUtils from 'utils/Url';



export function getPathCustomDomains(qs={}) {
  return urlUtils.appendQueryString(`/custom-domains`, qs);
}

export function getPathAddCustomDomain() {
  return `/custom-domains/add`;
}


export function getPathCustomPages(qs={}) {
  return urlUtils.appendQueryString(`/custom-pages`, qs);
}

export function getPathAddCustomPage() {
  return `/custom-pages/add`;
}

export function getPathEditCustomPage(pageId) {
  return `/custom-pages/${pageId}/edit`;
}
